import { FormApi, axios } from './config'
import { getStorage } from '@/utils/localstorage'
import { LS_WECHAT_USER_INFO_KEY } from '@/configs/constants'
import { proxyApi } from './common'

/**
 *查询问卷是否剩余提交次数
 *
 * @param {*} formId
 * @returns
 */
async function checkWechatUnique(formId) {
    try {
        let data = new FormData()
        const userInfo = getStorage(LS_WECHAT_USER_INFO_KEY)
        if (userInfo && userInfo.openid && formId) {
            data.append('WechatAppId', window.env.VUE_APP_APP_ID)
            data.append('WechatOpenId', userInfo.openid)
            data.append('structureId', formId)
            const res = await axios.post(FormApi + '/submit/wechatunique', data)
            return res.code === 200
        }
    } catch (error) {
        return false
    }
}
/**
 *获取联系人信息
 *
 * @param {*} keys
 */
function getLeadinfo(
    keys = [
        'FullName',
        'Industry',
        'Mailbox',
        'Department',
        'Organization',
        'Phone',
        'Position',
        'Sex',
        'FullAddress'
    ]
) {
    return proxyApi('wechat', 'leadinfo', keys)
}
/**
 *获取指定json
 *
 * @param {*} file
 * @returns
 */
async function getJson(file) {
    return await axios.get(file, {
        headers: {
            'Cache-Control': 'no-cache'
        }
    })
}
/**
 *微站限制
 *
 * @returns
 */
async function findLimit() {
    if (window.env.VUE_APP_SITE_ID) {
        return await proxyApi(
            'site',
            'findLimit',
            {
                type: 'site',
                uaId: 'UA-' + window.env.VUE_APP_SITE_ID
            },
            1
        )
    } else {
        return {}
    }
}
/**
 *获取问卷申请记录
 *
 * @param {*} formId
 * @param {*} [items=[]] 问卷name
 */
async function getSubmitResult(formId, items = []) {
    return await proxyApi('form', 'SubmitResult', {
        formId,
        items
    })
}
/**
 *微站权限
 *
 * @returns
 */
async function getAccess() {
    if (window.env.VUE_APP_SITE_ID) {
        return await proxyApi('site', 'access', {
            type: 'site',
            uaId: 'UA-' + window.env.VUE_APP_SITE_ID
        })
    } else {
        return { code: 200 }
    }
}

export {
    checkWechatUnique,
    getLeadinfo,
    getJson,
    getAccess,
    findLimit,
    getSubmitResult
}
